import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { ModalConfirmacao } from '../../../models/modal.model';

@Component({
  selector: 'app-modal-confirmacao-mensagem',
  templateUrl: './modal-confirmacao-mensagem.component.html',
  styleUrls: ['./modal-confirmacao-mensagem.component.scss']
})
export class ModalConfirmacaoMensagemComponent implements OnInit, OnChanges {

  @Input() opts: ModalConfirmacao;
  @Input() texto: string = '';

  @Output() confimarDialogo = new EventEmitter();
  @Output() cancelarDialogo = new EventEmitter();
  param: any;
  mensagemDefault: string;

  constructor() {

  }
  setOpts() {
    this.opts = this.opts || new ModalConfirmacao();
    this.opts.html = this.opts.html || '';
    this.opts.btnMsgOk = this.opts.btnMsgOk || 'Sim';
    this.opts.btnMsgCancelar = this.opts.btnMsgCancelar || 'Não';
    this.opts.tipo = typeof this.opts.tipo == 'undefined' ? 1 : this.opts.tipo;
  }

  ngOnInit() {
    //this.setOpts();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.opts) {
      this.setOpts();
    }
  }
  cancelar() {
    this.opts.aberto = false;
    this.cancelarDialogo.emit(this.param);
    if (this.mensagemDefault) {
      this.opts.html = this.mensagemDefault
    }
  }

  confimar() {
    this.opts.aberto = false;
    this.confimarDialogo.emit(this.param);
    if (this.mensagemDefault) {
      this.opts.html = this.mensagemDefault
    }
  }

  mostrar(mensagem: string, param?: any, index?: any) {
    this.opts.aberto = true;
    this.mensagemDefault = this.opts.html
    this.opts.html = mensagem;
    this.abrir(param, index);
  }

  abrir(param?: any, index?: any) {
    this.opts.aberto = true;
    if (typeof (index) == 'undefined') {
      this.param = param
    } else {
      this.param = { param, index };
    }
  }
}
